/**
 * This is the data for the EquiNos videos.
 */
export const EquiNosVideos = [
  {
    videoId: "p2PfSt1OjQQ",
    title: "EquiNos Ep 1 - Ben Bohmer, Cubicolor......",
  },
  {
    videoId: "dm_knHz_Fxg",
    title: "EquiNos Ep 2 - Nox Vahn, Gallago, Lane 8, Jimpster......",
  },
  {
    videoId: "7myYo-G8gnU",
    title: "EquiNos Ep 3 - Ben Bohmer, Nox Vahn, Tone Depth......",
  },
  {
    videoId: "6hkZCRllXoQ",
    title: "EquiNos Ep 4 - Ben Bohmer, Tinlicker, lane 8.....",
  },
  {
    videoId: "2BSXk4N2Mc4",
    title:
      "EquiNos EP 5 - Jody Wisternoff, Luca Musto, Franky Wah.... || Deep House Set",
  },
  {
    videoId: "6Y8Tl2Az_wQ",
    title:
      "EquiNos EP 6 - CamelPhat, Sultan + Shepherd, Pig & Dan || Deep House Set",
  },
  {
    videoId: "l7vbh0SPYUk",
    title:
      "EquiNos x Woulö EP 7 - Above and Beyond, Luttrel, Yotto.... || Guest Mix by Woulö|| Deep House Set",
  },
  {
    videoId: "rKLQEDJoFbI",
    title:
      "EquiNos EP 8 - Eelke Kleijn, Marsh, Fingerprint & Spencer Brown.... || Deep House ||",
  },
];

export const NoisyNosBanner =
  "https://firebasestorage.googleapis.com/v0/b/portfolio-235df.appspot.com/o/Screenshot%202024-09-02%20at%202.59.55%E2%80%AFPM.png?alt=media&token=34ade7df-7cc7-4fdb-971b-dc1e80220698";

export const NoisyNosVideoHighlight1 = {
  videoId: "bMa2UrmFG_M",
  title: "Pre Game Set || Noisynos || Diplo, Mochak....",
  description:
    "Welcome to NoisyNos! 🎶 Dive into an epic musical journey with our latest playlist, filled with House tracks that will get you in the perfect mood. Whether you're chilling, working, or partying, this playlist has something for everyone!",
};

export const NoisyNosVideoHighlight2 = {
  videoId: "F2dL_MXy35o",
  title: "sunday morning improvised || oliver heldens, fisher, durante ...",
  description:
    "Welcome to NoisyNos! 🎶 Dive into an epic musical journey with our latest playlist, filled with House tracks that will get you in the perfect mood. Whether you're chilling, working, or partying, this playlist has something for everyone!",
};
